module.exports = __webpack_public_path__ + "img/solution-bgimg.0d70d9f2.png";